import React, { useState, useEffect } from 'react';
import '../styles/Banners.css';
import { FaChevronRight, FaChevronLeft } from 'react-icons/fa6';
import axiosPost from '../helper/axios-helper';

export default function Banners() {
  const [banners, setBanners] = useState([]);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(false);
  const [autoPlay, setAutoPlay] = useState(true);

  useEffect(() => {
    fetchBanners();
  }, []);

  const fetchBanners = () => {
    axiosPost('banners/fetch', {}, {}, (data) => {
      const { success } = data;
      
      console.log(data);
      
      if (success) {
        setBanners(data.data);
      }
    });
  };

  useEffect(() => {
    let intervalId;
    
    if (autoPlay) {
      intervalId = setInterval(() => {
        handleNext();
      }, 5000);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [currentIndex, banners.length, autoPlay]);

  const handlePrev = () => {
    setFade(true);
    setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex === 0 ? banners.length - 1 : prevIndex - 1));
      setFade(false);
    }, 300);
    
    // Pause autoplay temporarily when user navigates manually
    setAutoPlay(false);
    setTimeout(() => setAutoPlay(true), 8000);
  };

  const handleNext = () => {
    setFade(true);
    setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % banners.length);
      setFade(false);
    }, 300);
    
    // Pause autoplay temporarily when user navigates manually
    setAutoPlay(false);
    setTimeout(() => setAutoPlay(true), 8000);
  };

  return (
    <div className='banners-container'>
      <div className={`banner-fade ${fade ? 'fade-out' : ''}`}>
        <img
          src={banners[currentIndex]?.image}
          alt={`Banner ${banners[currentIndex]?.index || currentIndex + 1}`}
          className='banner-image'
        />
      </div>
      <div className='banner-overlay'></div>
      
      {/* Navigation Arrows */}
      <div className='banner-navigation'>
        <button 
          className='banner-arrow banner-arrow-left' 
          onClick={handlePrev}
          aria-label="Previous banner"
        >
          <FaChevronLeft size={24} color='#fff' />
        </button>
        <button 
          className='banner-arrow banner-arrow-right' 
          onClick={handleNext}
          aria-label="Next banner"
        >
          <FaChevronRight size={24} color='#fff' />
        </button>
      </div>
      
      <div className='banner-event'>
        <div>
          {banners[currentIndex]?.logo && (
            <img src={banners[currentIndex].logo} style={{height: 150}} alt="Banner logo" />
          )}

          {banners[currentIndex]?.c2a && (
            <a 
              className='banner-event-btn' 
              href={banners[currentIndex].c2a} 
              target='_blank' 
              rel="noopener noreferrer"
              onClick={(e) => {
                // Handle internal links correctly
                const url = banners[currentIndex].c2a;
                const currentHost = window.location.origin;
                
                // Check if the link is to the current host
                if (url.startsWith('/') || url.includes(currentHost)) {
                  e.preventDefault();
                  
                  // Extract the path from the URL
                  let path;
                  if (url.startsWith('/')) {
                    path = url;
                  } else {
                    // Remove the domain part
                    path = url.replace(currentHost, '');
                    if (!path.startsWith('/')) path = '/' + path;
                  }
                  
                  // Use window.location or history API to navigate
                  window.location.href = path;
                }
                // External links will work normally with href
              }}
            > 
              <div className='banner-event-btn-title'>{banners[currentIndex]?.button}</div>
              <div className='banner-event-btn-icon'>
                <FaChevronRight size={14} color='#fff' />
              </div>
            </a>
          )}
        </div>
      </div>

      {banners[currentIndex]?.title && (
        <div className='banner-event-info'>
          <div className='banner-event-title'>{banners[currentIndex].title}</div>
          <div className='banner-event-body'>{banners[currentIndex]?.subtitle}</div>
        </div>
      )}
      
    </div>
  );
}